const session = {
  hasLoaded: false,
  currentPage: 0,
  hasMore: true,
};

export function canUseProjectListSessionCache(): boolean {
  return session.hasLoaded;
}

export function hydrateProjectListSessionState(): {
  currentPage: number;
  hasMore: boolean;
} {
  return {
    currentPage: session.currentPage,
    hasMore: session.hasMore,
  };
}

export function updateProjectListSessionCache(
  currentPage: number,
  hasMore: boolean,
): void {
  session.hasLoaded = true;
  session.currentPage = currentPage;
  session.hasMore = hasMore;
}

export function resetProjectListSessionCache(): void {
  session.hasLoaded = false;
  session.currentPage = 0;
  session.hasMore = true;
}
